import { all, put, takeLatest, call } from 'redux-saga/effects';
import { PaymentActionTypes } from 'types';
import {
  createCheckoutSessionSuccess,
  createCheckoutSessionFailure,
  checkCheckoutSessionStatusSuccess,
  checkCheckoutSessionStatusFailure,
  getPaymentTypePriceSuccess,
  getPaymentTypePriceFailure,
  confirmPostPaymentSuccess,
  confirmPostPaymentFailure
} from './actions';
import {
  createCheckoutSession,
  getPaymentTypePrice,
  getCheckoutSessionStatus,
  confirmPostPayment
} from 'services/payment.service';
import { executeRecaptcha } from 'utilities/recaptcha.util';

function* handleCreateCheckoutSession(request: any) {
  try {
    const response = yield call(createCheckoutSession, request.payload);
    if (response.error) {
      throw new Error(response.error.message);
    }
    yield put(createCheckoutSessionSuccess(response));
  } catch (err) {
    const errMsg = err?.message ? err.message : err?.toString();
    yield put(createCheckoutSessionFailure(errMsg));
  }
}

function* handleGetPaymentTypePrice(request: any) {
  try {
    const response = yield call(getPaymentTypePrice, request.payload);
    if (response.unitAmount) {
      yield put(
        getPaymentTypePriceSuccess({
          unitAmount: response.unitAmount / 100,
          includeTax: response.taxBehavior === 'inclusive'
        })
      );
      return;
    }
    yield put(
      getPaymentTypePriceFailure(
        response.error?.message || 'An unknown error occurred'
      )
    );
  } catch (err) {
    const errMsg = err?.message ? err.message : err?.toString();
    yield put(getPaymentTypePriceFailure(errMsg));
  }
}

function* handleCheckCheckoutSessionStatus(request: any) {
  try {
    const response = yield call(getCheckoutSessionStatus, request.payload);
    const status = response.status === 'complete' ? 'COMPLETED' : 'FAILED';
    yield put(
      checkCheckoutSessionStatusSuccess({
        status,
        paymentIntentId: response.paymentIntentId
      })
    );
  } catch (err) {
    yield put(
      checkCheckoutSessionStatusFailure(
        err?.message || 'An unknown error occurred'
      )
    );
  }
}

function* handleConfirmPostPayment(request: any) {
  try {
    const token = yield call(executeRecaptcha, 'submit');
    const response = yield call(
      confirmPostPayment,
      request.payload.postPaymentId,
      token,
      request.payload.purchaseOrderNumber || undefined
    );
    if (!response.success) {
      throw new Error(
        response.error?.message ||
          'Unable to confirm payment. Please try again.'
      );
    }
    yield put(confirmPostPaymentSuccess());
  } catch (err) {
    yield put(
      confirmPostPaymentFailure(err?.message || 'An unknown error occurred')
    );
  }
}

function* watchCreateCheckoutSession() {
  yield takeLatest(
    PaymentActionTypes.CREATE_CHECKOUT_SESSION_START,
    handleCreateCheckoutSession
  );
}

function* watchGetPaymentTypePrice() {
  yield takeLatest(
    PaymentActionTypes.GET_PAYMENT_TYPE_PRICE_START,
    handleGetPaymentTypePrice
  );
}

function* watchCheckCheckoutSessionStatus() {
  yield takeLatest(
    PaymentActionTypes.CHECK_CHECKOUT_SESSION_STATUS_START,
    handleCheckCheckoutSessionStatus
  );
}

function* watchConfirmPostPayment() {
  yield takeLatest(
    PaymentActionTypes.CONFIRM_POST_PAYMENT_START,
    handleConfirmPostPayment
  );
}

function* PaymentSagas() {
  yield all([
    call(watchCreateCheckoutSession),
    call(watchGetPaymentTypePrice),
    call(watchCheckCheckoutSessionStatus),
    call(watchConfirmPostPayment)
  ]);
}

export default PaymentSagas;
